import _extends from "@babel/runtime/helpers/esm/extends";
import { createNamespace } from '../utils';
import Button from '../button';

var _createNamespace = createNamespace('bottom-button'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    safeAreaInsetBottom: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  methods: {},
  render: function render() {
    var h = arguments[0];
    var slots = this.slots;
    return h("div", {
      "class": bem({
        'safe-area-inset-bottom': this.safeAreaInsetBottom
      })
    }, [h("div", {
      "class": bem('box', {
        embedded: this.embedded
      })
    }, [slots() ? slots() : h(Button, {
      "attrs": _extends({
        "block": true
      }, _extends({}, this.$attrs), {
        "size": "large"
      }),
      "on": _extends({}, this.$listeners)
    })])]);
  }
});